export const datePatternOptions = [
    { pattern: "dd/MM/yy" },
    { pattern: "dd/MM/yyyy" },
    { pattern: "MM/dd/yy" },
    { pattern: "MM/dd/yyyy" },
]